import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";

import { server } from "../../common";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelectAccess } from "../../store/stateFunctions";
import useQuickLook from "../../quicklook/useQuickLook";

const initialValues = {
  position: "",
  last_date: "",
  internship_description: "",
  internship_mode: "",
  company_name: "",
  location: "",
  internship_period: "",
  links: "",
  image: null,
  address: "",
  noofposition: "",
  skills: "",
};

const swalalert = withReactContent(Swal);

const AddInternalInternships = ({ role }) => {
  document.title = "Internal User";
  const user = useSelectAccess("Internal User");

  const [show, setShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const displayFile = useQuickLook();

  const handleClose = () => setShow(false);

  const handleShow = () => {
    setIsEditMode(false);
    setSelectedData(null);
    formik.setValues(initialValues);
    setShow(true);
  };

  const handleShowEdit = (data) => {
    setSelectedData(data);
    setIsEditMode(true);
    setShow(true);
  };

  useEffect(() => {
    getData();
    // Check if in edit mode and selectedData is available
    if (isEditMode && selectedData) {
      formik.setValues({
        position: selectedData.position,
        last_date: selectedData.last_date,
        internship_description: selectedData.internship_description,
        internship_mode: selectedData.internship_mode,
        company_name: selectedData.company_name,
        location: selectedData.location,
        internship_period: selectedData.internship_period,
        links: selectedData.links,
        noofposition: selectedData.noofposition,
        address: selectedData.address,
        skills: selectedData.skills,
        image: null, // Assuming you want to keep the file input empty for security reasons
      });
    }
  }, [isEditMode, selectedData]);

  // Get Gallery
  const getData = () => {
    server
      .get("/int_internship/getallind_internship", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete gallery
  const deleteInternShip = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.position} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/int_internship/deleteind_internship/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire(
                  "Deleted!",
                  "Internship has been deleted.",
                  "success"
                );
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // update news
  const handleUpdate = (values) => {
    const formData = new FormData();
    formData.append("position", values.position);
    formData.append("last_date", values.last_date);
    formData.append("internship_description", values.internship_description);
    formData.append("internship_mode", values.internship_mode);
    formData.append("internship_period", values.internship_period);
    formData.append("company_name", values.company_name);
    formData.append("links", values.links);
    formData.append("skills", values.skills);
    formData.append("location", values.location);
    formData.append("noofposition", values.noofposition);
    formData.append("address", values.address);

    if (values.image) {
      formData.append("image", values.image);
    }

    server
      .put(`/int_internship/update_approval_status/${values.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        formik.resetForm();
        getData();
        toast.success("Internship Updated successfully");
        handleClose();
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const formik = useFormik({
    initialValues: isEditMode ? selectedData : initialValues,
    validationSchema: Yup.object({
      position: Yup.string().required("Enter a Internship Position"),
      last_date: Yup.string().required("Enter a Internship Last Date"),
      internship_period: Yup.string().required("Enter a Internship Period"),
      internship_description: Yup.string().required(
        "Enter a Internship Description"
      ),
      internship_mode: Yup.string().required("Enter a Internship Mode"),
      links: Yup.string().required("Enter a Website link"),
      company_name: Yup.string().required("Enter a title"),
      skills: Yup.string().required("Enter a Skills"),
      location: Yup.string().required("Enter a Internship Location"),
      noofposition: Yup.string().required("Enter a Number of positions"),
      address: Yup.string().required("Enter a Company address"),
      image: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          // Check the file size (if required)
          // Modify the limit according to your requirements
          return value ? value.size <= 5000000 : true;
        }),
    }),
    onSubmit: (values, action) => {
      if (isEditMode) {
        handleUpdate({ ...values, id: selectedData.id });
      } else {
        if (!values.image) {
          toast.error("Please select a images");
          return;
        }
        const formData = new FormData();
        formData.append("position", values.position);
        formData.append("last_date", values.last_date);
        formData.append(
          "internship_description",
          values.internship_description
        );
        formData.append("internship_period", values.internship_period);
        formData.append("internship_mode", values.internship_mode);
        formData.append("company_name", values.company_name);
        formData.append("links", values.links);
        formData.append("skills", values.skills);
        formData.append("location", values.location);
        formData.append("noofposition", values.noofposition);
        formData.append("address", values.address);
        formData.append("image", values.image);

        server
          .post("/int_internship/addint_internship", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: user.authToken,
            },
          })
          .then(function (response) {
            if (response.status === 200 || response.status === 201) {
              toast.success("Internship Added successfully");
              formik.resetForm();
              handleClose();
              getData();
            }
          })
          .catch(function (error) {
            if (error.response?.data?.message)
              toast.error(error.response.data.message);
            else if (error.response?.data?.error) {
              toast.error(error.response.data.error);
            } else toast.error("Failed to connect to server");
          });
      }
    },
  });

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/internship/admfilter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      <div className="container">
        <div className="row my-3">
          <div className="col-md-4">
            <input
              type="search"
              name=""
              className="form-control"
              placeholder="Search"
              id=""
            />
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <select
              className="form-control"
              name=""
              id=""
              onChange={(e) => FilterData(e)} // Pass the event to FilterData
            >
              <option value="2days" defaultValue>
                Last 2 days
              </option>
              <option value="month" defaultValue>
                This Month
              </option>
              <option value="3months">Last 3 Months</option>
              <option value="6months">Last 6 Months</option>
            </select>
          </div>
        </div>
        <div className="d-flex position-relative mb-3 justify-content-center ">
          <h5 className="m-auto text-center">Previous Internships</h5>
          <Button variant="contained" color="info" onClick={handleShow}>
            Add Internships
          </Button>

          <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                {" "}
                {isEditMode
                  ? "Edit Internship Details"
                  : "Add Internship Details"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col>
                    <div className="form-outline mb-2">
                      <TextField
                        name="company_name"
                        margin="dense"
                        type="text"
                        placeholder="Company Name"
                        variant="outlined"
                        label="Company Name"
                        value={formik.values.company_name}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.company_name ? (
                        <p className="text-danger">
                          {formik.errors.company_name}
                        </p>
                      ) : null}
                    </div>

                    <div className="form-outline mb-2">
                      <TextField
                        name="internship_description"
                        margin="dense"
                        type="text"
                        placeholder="Description"
                        variant="outlined"
                        label="Internship Description"
                        value={formik.values.internship_description}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.internship_description ? (
                        <p className="text-danger">
                          {formik.errors.internship_description}
                        </p>
                      ) : null}
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="position"
                        margin="dense"
                        type="text"
                        placeholder="Internship Position"
                        variant="outlined"
                        label="Internship Position"
                        value={formik.values.position}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.position ? (
                        <p className="text-danger">{formik.errors.position}</p>
                      ) : null}
                    </div>

                    <div className="form-outline mb-2">
                      <TextField
                        name="internship_period"
                        margin="dense"
                        type="text"
                        placeholder="Internship Period"
                        variant="outlined"
                        label="Internship Period"
                        value={formik.values.internship_period}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.internship_period ? (
                        <p className="text-danger">
                          {formik.errors.internship_period}
                        </p>
                      ) : null}
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="links"
                        margin="dense"
                        type="text"
                        placeholder="Website Url"
                        variant="outlined"
                        label="Website Url"
                        value={formik.values.links}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.links ? (
                        <p className="text-danger">{formik.errors.links}</p>
                      ) : null}
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="noofposition"
                        margin="dense"
                        type="text"
                        placeholder="Number of positions"
                        variant="outlined"
                        label="Number of positions"
                        value={formik.values.noofposition}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.noofposition ? (
                        <p className="text-danger">
                          {formik.errors.noofposition}
                        </p>
                      ) : null}
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group mb-2">
                      <TextField
                        name="last_date"
                        margin="dense"
                        type="date"
                        placeholder="Last Date"
                        variant="outlined"
                        label="Last Date of Application"
                        value={formik.values.last_date}
                        onChange={formik.handleChange}
                        InputProps={{
                          inputProps: {
                            min: new Date().toISOString().substring(0, 10),
                          },
                        }}
                        fullWidth
                        required
                        style={{ margin: "8px 0" }}
                        InputLabelProps={{ shrink: true }}
                      ></TextField>
                      {formik.errors.last_date ? (
                        <p className="text-danger">{formik.errors.last_date}</p>
                      ) : null}
                    </div>
                    <div className="mb-2">
                      <FormControl fullWidth required className="mt-2">
                        <InputLabel id="demo-simple-select-label">
                          Internship Mode
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Year"
                          variant="outlined"
                          name="internship_mode"
                          onChange={formik.handleChange}
                          value={formik.values.internship_mode}
                          required
                        >
                          <MenuItem value="online">Online</MenuItem>
                          <MenuItem value="offline">Offline</MenuItem>
                        </Select>
                        {formik.errors.internship_mode ? (
                          <p className="text-danger mb-0">
                            {formik.errors.internship_mode}
                          </p>
                        ) : null}
                      </FormControl>
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="location"
                        margin="dense"
                        type="text"
                        placeholder="location"
                        variant="outlined"
                        label="Location"
                        value={formik.values.location}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.location ? (
                        <p className="text-danger">{formik.errors.location}</p>
                      ) : null}
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="image"
                        margin="dense"
                        type="file"
                        variant="outlined"
                        label="Company logo"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <label htmlFor="image">Upload Image</label>
                            </InputAdornment>
                          ),
                          inputProps: {
                            accept: ".jpg, .png, .jpeg",
                            onChange: (event) => {
                              formik.setFieldValue(
                                "image",
                                event.currentTarget.files[0]
                              );
                            },
                          },
                        }}
                      />
                      {formik.errors.image ? (
                        <p className="text-danger">{formik.errors.image}</p>
                      ) : null}
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="skills"
                        margin="dense"
                        type="text"
                        placeholder="Skills"
                        variant="outlined"
                        label="Skills"
                        value={formik.values.skills}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.skills ? (
                        <p className="text-danger">{formik.errors.skills}</p>
                      ) : null}
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="address"
                        margin="dense"
                        type="text"
                        placeholder="Company Address"
                        variant="outlined"
                        label="Company Address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.address ? (
                        <p className="text-danger">{formik.errors.address}</p>
                      ) : null}
                    </div>
                  </Col>
                </Row>

                <div className="pt-1 mb-2 ">
                  <Button variant="contained" type="submit">
                    {isEditMode ? "Update" : "Post"}
                  </Button>
                  <Button
                    className="float-end"
                    variant="contained"
                    color="warning"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </div>
        <div className="container" style={{ overflow: "scroll" }}>
          <table
            className="table table-striped "
            style={{ border: "1px solid #ddd" }}
          >
            <thead>
              <tr>
                <th className="border">Sr. No.</th>
                <th className="border">Position</th>
                <th className="border">Description</th>
                <th className="border">Company Name</th>
                <th className="border">Company Logo</th>
                <th className="border">Internship Period</th>
                <th className="border">Internship Mode</th>
                <th className="border">No Of Positions</th>
                <th className="border">Website Url</th>
                <th className="border">Skills</th>
                <th className="border">Location</th>
                <th className="border">Update</th>
                <th className="border">Delete</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td className="border">{item.position}</td>
                    <td className="border">{item.internship_description}</td>
                    <td className="border">{item.company_name}</td>
                    <td className="border">
                      <a href={item.image} target="_blank">
                        <img
                          width="50"
                          height="50"
                          src={item.image}
                          // alt={item.file}
                        />
                      </a>
                    </td>
                    <td className="border">{item.internship_period}</td>
                    <td className="border">{item.internship_mode}</td>
                    <td className="border">{item.noofposition}</td>
                    <td className="border">{item.links}</td>
                    <td className="border">{item.skills}</td>
                    <td className="border">{item.location}</td>
                    <td className="border">
                      <div className="btn banner text-white">
                        <AiFillEdit onClick={() => handleShowEdit(item)} />
                      </div>
                    </td>
                    <td className="border">
                      <div className="btn banner text-white">
                        <AiFillDelete onClick={() => deleteInternShip(item)} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>{" "}
        </div>
      </div>
    </>
  );
};

export default AddInternalInternships;
